// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import './PageHeader.css';

// header

type Props = {
    sourceId: number,
    sport: string,
    title: string,
    sources: { [key: string]: any }
};

const PageHeader = (props: Props) => {
    let sourceId = props.sourceId;
    if (sourceId === undefined) {
        sourceId = 4;
    }
    const returnURL = '/apps/propositions/' + props.sport;
    const spanClass = 'view-header-primary-sport ' + props.sport.toUpperCase();
    const display = (
        <div className={'page-header'}>
            <div className={spanClass}>{props.sport.toUpperCase()}</div>
            <a href={returnURL}>
                <h1 className="view-header-primary-title">{props.title}</h1>
            </a>
            <nav className={'page-header-nav center'}>
                <ul className={'tabs'}>
                    {props.sources.map(function(source) {
                        const sourceURL = '/apps/propositions/' + props.sport;
                        return (
                            <li key={source.id}>
                                <Link to={sourceURL} className={+sourceId === source.id ? 'active' : ''}>
                                    {source.display_name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );

    return display;
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/Navigation/PageHeader/PageHeader.js